module.exports = __webpack_public_path__ + "img/rec-10.e02b9f32.jpg";